export default __webpack_public_path__ + "static/media/sardor.ffcdf9a1.jpg";